import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from '../_services/customer.service'
import { DebtorService } from '../_services/debtor.service'
import { DataService } from '../_helpers/dataservice.service'
import { InvoicesService } from '../_services/invoices.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { ExcelService } from '../_helpers/index';
import { AppConfig } from '../_helpers/appconfig.service';
import { Router, ActivatedRoute } from "@angular/router";
import { Debtor } from '../_models/debtor.interface'
import { ParameterData } from '../_helpers/index';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AuthService, DebtorDataService, ExcelDateConvertService, PayoutService, UserService } from '../_services';
import { CurrencyPipe } from '@angular/common';
import * as moment from 'moment';
import { SelectionModel } from '@angular/cdk/collections';
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';

@Component({
  selector: 'customerdetail',
  templateUrl: './customerdetail.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css'],
  encapsulation: ViewEncapsulation.None
})




export class CustomerDetailComponent implements OnInit {

  public customer_public_id: string;

  searchFilterForm: FormGroup;
  filterValue;
  customerDetail: any;

  name: string;
  code: string;
  email: string;
  phone: string;
  document: string;
  document_type: string;
  status: string;

  street: string;
  provice: string;
  city: string;
  district: string;
  created: string;
  tempStatus = "";

  jwtTokenObj: any;

  //angular material table related variables and properties
  invoiceListDataSource = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) paginatorBottom: MatPaginator;
  displayedColumns: string[] = ['select','created', 'metadata.order_description', 'sub_total.value', 'late_fee.value', 'total.value', 'status', 'metadata.payment_method','actions'];


  invoiceListExcelExportData: any;

  //user public key used to access the kcore api
  public_key: any;
  pageSize: number;
  PageSizeOptions: number[];
  isLoading = true;
  paymentDetail : any;
  customerId: any;
  application: any;
  isUpdateAvailable = true;
  isInvoiceCreateAvailable = true;
  isInvoiceUpdateAvailable = true;
  isInvoiceExportExcelAvailable = true;
  isInvoiceDeleteAvailable = true;
  isInvoiceRejectAvailable = true;
  isInvoiceReadAvailable = true;
  userDetails: any;
  userRole: any;
  userRoleStatus: any;
  invoiceRejectForm: FormGroup;
  rejectInvoiceId: any;
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  selection = new SelectionModel<any>(true, []);
  /**
   * constructor function.
   */
  constructor(private router: Router, private customerService: CustomerService
    , private dataService: DataService, private debtorService: DebtorService, private excelService: ExcelService
    , private formBuilder: FormBuilder, private parameterData: ParameterData
    , private readonly activatedRoute: ActivatedRoute
    , private invoicesService: InvoicesService
    , private spinnerService: Ng4LoadingSpinnerService
    , private auth: AuthService
    , private payoutService: PayoutService
    , private userService: UserService
    , private _fb: FormBuilder
    , private debtorDataService:DebtorDataService
    , private currencyPipe: CurrencyPipe
    , private excelDateConvertService:ExcelDateConvertService
  ) {
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.InitialSetup();



  }//end constructor


  /**
   * this function is used to apply the filter functionality to the debtor invoice grid
   */
  applyFilter() {

    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.filterValue = this.filterValue.trim();
    this.filterValue = this.filterValue.toLowerCase();
    this.invoiceListDataSource.filter = this.filterValue;
  }//end


  InitialSetup() {
    this.invoiceRejectForm = this._fb.group({
      description: new FormControl('',[Validators.required]),
    })
  }
  /**
   * ngOnInit function.
   */
  ngOnInit() {
    window.scroll(0, 0);
    this.spinnerService.show();
    this.checkThisPageGrants();
    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    let browserStorageAdmin = localStorage.getItem('isadmin');

    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');
      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
    }

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;


    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);

      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {

      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 0;

      this.offsetTimeVal = (this.offsetTimeZone * 3600000);

      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;


    }
    this.application = localStorage.getItem('application')
    //used to retrieve the customer public id
    let params: any = this.activatedRoute.snapshot.params;
    this.public_key = params.id;


    this.searchFilterForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });
    if(this.application == 'PAYOUTS'){
      this.displayedColumns = ['select','created', 'metadata.order_description', 'sub_total.value', 'late_fee.value', 'total.value', 'status','actions'];

    }
    this.GetIndividualDebtorDetails();
    // this.getDebdorInvoiceList();
  }//end

  public async initializeData() {

  }


   GetIndividualDebtorDetails() {
    this.debtorService.getDebtor(this.public_key).subscribe((data: Debtor) => {
      this.name = data.name;
      this.code = data.external_id;
      this.email = data.email;
      this.phone = data.phone;
      this.document_type = data.document_type;
      this.document = this.document_type + " " + data.document_id;
      this.status = data.status;
      this.tempStatus = data.status;
      this.status = (this.status == "ACTIVE") ? "Activo" : "Inactivo";

      this.street = data.address.street;
      this.provice = data.address.state;
      this.city = data.address.city;
      this.district = data.address.county;

      this.created = data.created;
      this.customerId = data.public_id;
     // this.getPspAccountName();
     this.getDebdorInvoiceList();
    },
      error => {
        console.log('Failed while trying to get Indvidual Debtor Detail. ' + error);
      });
  }//end

  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  ngAfterViewInit(){
    this.invoiceListDataSource.sort = this.sort;
    this.invoiceListDataSource.paginator = this.paginator;
  }

  getDebdorInvoiceList() {
    this.debtorService.getDebtorInvoiceList(this.public_key).subscribe(data => {
      let resources = data["data"];
      this.invoiceListDataSource.data = resources;
      this.invoiceListDataSource.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
      this.invoiceListExcelExportData = resources;
      this.spinnerService.hide();
    },
      error => {
        console.log('Failed while trying to fetch debtors invoice list. ' + error);
      });
  }//end



  /**
 * this function is used to export the debtor invoice list.
 * input data variable invoiceListExcelExportData; which value assigned in getDebdorInvoiceList()  function
 */
  exportAsXLSX() {
    if (this.selection.selected.length == 0) {
      this.setExportExcelFileData(this.invoiceListExcelExportData);
    } else {
      this.setExportExcelFileData(this.selection.selected);
    }

  }//end


  /**
   * this function is used to edit the customer details.
   */
  editCustomer() {


    this.parameterData.DebtorIdParameters = this.public_key;
    this.router.navigate([`/customers/${this.public_key}/edit`]);

  }//end



  /** This function is used to edoy the create invoice details component; 
  * it accepts element(row) as parameter 
  * navigate to customer detail component
  */
  createInvoiceDetails() {
    //this.parameterData.DebtorIdParameters = this.public_key;
    var data = {
      fromPage: 'invoiceDetail',
      name: this.name,
      public_id: this.public_key
    };
    this.debtorDataService.setPreSelectDebtorSharedData(data);
    this.router.navigate(['/invoices/create']);
  }

  duplicateInvoiceDetails(publicid) {
    var data = {
      fromPage: 'invoiceDetail',
      name: this.name,
      public_id: this.public_key
    };
    this.debtorDataService.setPreSelectDebtorSharedData(data);
    this.parameterData.InvoiceIdParameters = publicid;
    this.router.navigate(['/invoices/create']);
  }
  /**
  * this function is used to get the Document type Name.
  * input parameter is document type Id value, which is number and returns document type name
  */

  viewInvoice(id) {
    const application = localStorage.getItem('application');
    if (AccountTypeOptions[application] != undefined) {
      this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${id}/view`]);
    }
  }

  editInvoice(id) {
    const application = localStorage.getItem('application');
    if (AccountTypeOptions[application] != undefined) {
      this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${id}/edit`]);
    }
  }

  /**
 * this function is used to redirect to the right component based on input.
 */
invoicegridActionClick(viewtype, publicid) {


    switch (viewtype) {
      case 'invoiceview':
        this.viewInvoice(publicid);
        break;
      case 'invoiceedit':
        this.editInvoice(publicid);
        break;
      case 'invoicedelete':
        this.onConfirmInvoice(publicid);

        break;
      case 'invoicedupicate':
        this.duplicateInvoiceDetails(publicid);
        break;

      case 'invoicereject':
        this.InitialSetup();
        this.rejectInvoiceId = publicid;
        //this.rejectInvoice(publicid);
        break;

      default:
        this.viewInvoice(publicid);

    }//end switch


  }//end

  rejectInvoice() {
    this.spinnerService.show();
    let rejectDescription = this.invoiceRejectForm.controls['description'].value;
    this.payoutService.rejectInvoice(this.rejectInvoiceId,rejectDescription).subscribe(result => {
      this.getDebdorInvoiceList();
    },
    error => {
        console.log('Failed while trying to reject the invoice Details.' + error);
    })
}

  onConfirmInvoice(publicid) {
    this.spinnerService.show();
    this.invoicesService.deleteInvoice(publicid)
      .subscribe((result) => {

        this.getDebdorInvoiceList();
      }, error => {
        console.log('Failed while trying to cancel the invoice Details.' + error);
      });
  } //end method


  setExportExcelFileData(excelExportData) {


    var excelHeader;
    if (this.application != "PAYOUTS") {
      excelHeader = ["FECHA DE CREACION", "DESCRIPCIÓN", "SUBTOTAL", "MORA", "TOTAL", "ESTADO", "METODO DE PAGO"]
    } else {
      excelHeader = ["FECHA DE CREACION", "DESCRIPCIÓN", "SUBTOTAL", "MORA", "TOTAL", "ESTADO"]
    }
    var arrFinalData = [];
    var object_temp = {};
    var k = 0;
    var columnsKeyNames = [];

    for (k = 0; k < excelExportData.length; k++) {
      var singleRec_temp = excelExportData[k];
      delete singleRec_temp['livemode'];

      delete singleRec_temp['object'];



      columnsKeyNames = Object.keys(singleRec_temp);



      var created_temp;
      // var due_datetime_temp;
      // var expiration_datetime_temp;
      var description_temp;
      var external_id_temp;
      var debtor_temp;
      var creditor_temp;
      var sub_total_temp;
      var late_fee_temp;
      var total_temp;
      var status_temp;
      var Metododepago_temp;

      object_temp = {};

      for (var i = 0; i < columnsKeyNames.length; i++) {
        if (columnsKeyNames[i] == "created") {
          created_temp = singleRec_temp[columnsKeyNames[i]];
        }
        if (columnsKeyNames[i] == "metadata") {
          description_temp = singleRec_temp[columnsKeyNames[i]].order_description;
        }
        // if (columnsKeyNames[i] == "due_datetime") {
        //   due_datetime_temp = singleRec_temp[columnsKeyNames[i]];
        // }

        // if (columnsKeyNames[i] == "expiration_datetime") {
        //   expiration_datetime_temp = singleRec_temp[columnsKeyNames[i]];
        // }

        if (columnsKeyNames[i] == "invoice_id") {
          external_id_temp = singleRec_temp[columnsKeyNames[i]];
        }

        



        if (columnsKeyNames[i] == "total") {
          total_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[i]].value, "", "");

        }

        if (columnsKeyNames[i] == "sub_total") {
          sub_total_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[i]].value, "", "");
        }


        if (columnsKeyNames[i] == "late_fee") {
          late_fee_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[i]].value, "", "");
        }

        var statusEnglish;
        if (columnsKeyNames[i] == "status") {
          statusEnglish = singleRec_temp[columnsKeyNames[i]];

          switch (statusEnglish) {
            case 'NEW':
              status_temp = 'Nuevo'
              break;
            case 'PENDING':
              status_temp = 'Pendiente'
              break;
            case 'PROCESSING':
              status_temp = 'Pendiente'
              break;
            case 'PAID':
              status_temp = 'Pagado'
              break;
            case 'VOIDED':
              status_temp = 'Anulado'
              break;
            case 'EXPIRED':
              status_temp = 'Expirado'
              break;
            case 'VOIDED_CUSTOMER':
              status_temp = 'Anulado'
              break;
            case 'OVERDUE':
              status_temp = 'Vencido'
              break;
            case 'PAYMENT_ON_HOLD':
              status_temp = 'Pendiente'
              break;
            case 'REJECTED':
              status_temp = 'Rechazado'
              break;
            default:
              status_temp = statusEnglish;

          }//end switch

        }
        if (columnsKeyNames[i] == "status") {
          statusEnglish = singleRec_temp[columnsKeyNames[i]];

          switch (statusEnglish) {
            case 'PAID':
              Metododepago_temp = this.filterPspAccountName(singleRec_temp['public_id'])
              break;
            case 'VOIDED':
              Metododepago_temp = '-'
              break;
            default:
              Metododepago_temp = '-'
          }//end switch

        }

      }//end for



      // for (var j = 0; j < excelHeader.length; j++) {
      //   if (excelHeader[j] == "FECHA DE CREACION") {
      //     object_temp[excelHeader[j]] = created_temp
      //   }
      //   if (excelHeader[j] == "Descripción") {
      //     object_temp[excelHeader[j]] = description_temp
      //   }
      //   // if (excelHeader[j] == "VENCIMIENTO") {
      //   //   object_temp[excelHeader[j]] = due_datetime_temp;
      //   // }

      //   // if (excelHeader[j] == "EXPIRACION") {
      //   //   object_temp[excelHeader[j]] = expiration_datetime_temp;
      //   // }

      //   if (excelHeader[j] == "ID Orden de Pago") {
      //     object_temp[excelHeader[j]] = external_id_temp;
      //   }



      //   if (excelHeader[j] == "SUBTOTAL") {
      //     object_temp[excelHeader[j]] = sub_total_temp;
      //   }


      //   if (excelHeader[j] == "MORA") {
      //     object_temp[excelHeader[j]] = late_fee_temp;
      //   }


      //   if (excelHeader[j] == "TOTAL") {
      //     object_temp[excelHeader[j]] = total_temp;
      //   }


      //   if (excelHeader[j] == "ESTADO") {
      //     object_temp[excelHeader[j]] = status_temp;
      //   }
      //   if (this.application != "PAYOUTS") {
      //     if (excelHeader[j] == "Metodo de pago") {
      //       object_temp[excelHeader[j]] = Metododepago_temp;
      //     }
      //   }


      // }//end for




      if (this.application != "PAYOUTS") {
        arrFinalData.push([this.excelDateConvertService.convertExcelDateTime(created_temp),description_temp, sub_total_temp, late_fee_temp, total_temp, status_temp, Metododepago_temp]);
      }else{
        arrFinalData.push([this.excelDateConvertService.convertExcelDateTime(created_temp),description_temp, sub_total_temp, late_fee_temp, total_temp, status_temp]);
      }
    }

    this.excelService.generateCustomerInvoicesExcelFile(excelHeader, arrFinalData, 'InvoiceList', localStorage.getItem('application'));


  }//end function

  // getPspAccountName() {
  //   this.customerService.getPspAccountName(this.customer_public_id).subscribe(result => {
  //       this.paymentDetail = result.data;
  //       this.getDebdorInvoiceList();
  //   }, error => {
  //       console.log('Failed while trying to getPspAccountName' + error);
  //   } )
  // }
  // convertExcelGMTTime(value) {
  //   var dateTimeZoneDiff = value.split(/[- :]/),
  //     dateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
  //   dateFinal.setMilliseconds(Number(this.offsetTimeVal));
  //   var dateString = moment(dateFinal).format('MM/DD/YYYY HH:mm:ss');
  //   var dateObj = new Date(dateString);
  //   var momentObj = moment(dateObj);
  //   var momentString = momentObj.format('DD/MM/YYYY HH:mm:ss'); // 2016-07
  //   return momentString;
  // }
  
  filterPspAccountName(invoice_Id) {
    if (this.paymentDetail != undefined) {
      let value = this.paymentDetail.filter(item => item.customer.public_id == this.customerId && item.invoice_list.some(x => x.public_id == invoice_Id));
      if (value.length > 0) {
        return value["0"].metadata.psp_account.name
      }
      else {
        return "-"
      }
    }
    else {
      return "-"
    }
  }

  async getUserRoleStatus() {
    try {
        const data = await this.userService.getUserDetails(localStorage.getItem('userId'));
        this.userDetails = data;
        this.userRole = this.userDetails.role;
        this.userRoleStatus = this.userDetails.status;
    }
    catch (error) {
        console.log('Failed while trying to getUserRoleStatus.' + error)
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.invoiceListDataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.invoiceListDataSource.data.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  removeSelectedRows(){
    this.selection.selected.forEach(item => {
      this.invoicesService.deleteInvoice(item.public_id).subscribe(data => {
        this.getDebdorInvoiceList()
      },
        error => {
          console.log('Failed! while trying to the invoices delete. ' + error.error);
        });
    });
    this.selection = new SelectionModel<Element>(true, []);
  }

  viewInvoiceDetails(element ) {

    const application = localStorage.getItem('application');
    if (AccountTypeOptions[application] != undefined) {
      this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${element.public_id}/view`]);
    }
  }

  async checkThisPageGrants() {
    await this.getUserRoleStatus();
    await this.auth.isKashioGrantsAvailable();
    this.isUpdateAvailable = this.auth.checkGrants('CUSTOMERS','UPDATE');
    this.isInvoiceCreateAvailable = this.auth.checkGrants('INVOICES','CREATE');
    this.isInvoiceUpdateAvailable = this.auth.checkGrants('INVOICES','UPDATE');
    this.isInvoiceExportExcelAvailable =  this.auth.checkGrants('INVOICES','EXPORT');
    this.isInvoiceDeleteAvailable = this.auth.checkGrants('INVOICES','DELETE');
    this.isInvoiceReadAvailable = this.auth.checkGrants('INVOICES', 'READ');
    if( localStorage.getItem('application') == 'PAYOUTS' && this.userRole == 'KashIO-OPS' && this.userRoleStatus == 'ACTIVE'){
      this.isInvoiceRejectAvailable = this.auth.checkGrants('INVOICES', 'REJECT');
    }else {
      this.isInvoiceRejectAvailable = false;
    }
  }

}//end
